import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import ContractorForm from "./contractorComponents/ContractorForm";

import {
  useGetContractorDetailQuery,
  useUpdateContractorMutation,
} from "store/services/contractorApi";

import { useAppMeta } from "hooks";

const ContractorEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Contractors", path: "/app/crm/contractor/list" },
    { title: "Edit Contractor" },
  ];

  // RTK Query
  const {
    data: contractorDetail,
    isLoading: loadingContractor,
    error,
  } = useGetContractorDetailQuery(id);

  const [updateContractor, { isLoading: updatingContractor }] =
    useUpdateContractorMutation();

  const handleUpdateContractor = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateContractor(_payload).unwrap();
      toast.success("Contractor successfully updated!");
      navigate(`/app/crm/contractor/${id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Contractor!");
    }
  };

  useAppMeta("Edit Contractor");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingContractor || updatingContractor}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ContractorForm
          isBusy={loadingContractor || updatingContractor}
          contractorDetail={contractorDetail}
          onSubmit={handleUpdateContractor}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ContractorEditScreen;
